<template>
	<b-modal :hide-footer="true" :title="$t('')" centered id="create-pasta">
		<div class="row px-3">
			<div class="col-12 alert alert-danger" v-if="error">
				{{ error }}
			</div>
			<div class="row col-12 px-3 d-flex justify-content-center" v-if="loading">
				<load mode="table" />
				<h5 class="my-3">
					Criando a pasta <b>{{ nome }}</b>
				</h5>
			</div>
			<form v-else @submit.prevent="submit" ref="addItem" class="col-12 px-0">
				<div class="row">
					<form-input label="Digite o nome da Pasta" v-model="nome" />
				</div>
				<div class="row px-2 d-flex justify-content-end">
					<button class="btn btn-primary btn-sm" @click="submit">Criar</button>
				</div>
			</form>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["path"],
	data() {
		return {
			nome: "",
			error: "",
			loading: false,
		};
	},
	methods: {
		submit() {
			this.loading = true;
			this.error = null;
			axios
				.post(`api/dashboard/addPasta`, {
					nome: this.nome,
					caminho: this.path,
				})
				.then((response) => {
					if (response.data.error) {
						this.error = response.data.error;
					} else {
						this.$emit("addpasta", response.data);
						this.$bvModal.hide("create-pasta", this.path);
						this.error = null;
						this.nome = "";
					}
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>
